import React, { Component } from 'react';
import moment from "moment";
import Current2 from '../Current2';
import Scenario2 from '../Scenario2';
import Forecast from '../Forecast';
import { Container } from 'react-bootstrap';
import API from '../../utils/api';
import { Prev } from 'react-bootstrap/PageItem';




class Dashboard extends Component {


    constructor(props) {
        super(props)

        this.state = {
            observedStageData: null,
            forecastStageData: null,
            forecastDateReading: null,
            stageLevels: null,
            observedFlowData: null,
            forecastFlowData: null,
            totalData: null,
            buildingsCurrent: null,
            buildingsScenario: null,
            returnPeriod: null,
            buildingsForecast: null,
            buildingsCurrentCritical: null,
            buildingsForecastCritical: null,
            buildingsScenarioCritical: null,
            currentElevation: null,
            scenarioSliderValue: null,
            forecastSliderValue: null,
            forecastStageValue: null,
            peakStage: null,
            peakElevation: null,
            peakDateTime: null,
        }

    }

    // get gage data objects from api response
    cleanNewGageData = (data) => {
        //change filter to every 15 min
        //let gageData = data.filter(item => item.dateReading.includes(':00:00'));
        let gageData = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i].dateReading.includes(':00') || data[i].dateReading.includes(':15') || data[i].dateReading.includes(':30') || data[i].dateReading.includes(':45')) {
                // append to new array
                //var newDate = new Date(data[i].dateReading + "Z").toString();
                //data[i].dateReading = newDate;
                gageData.push(data[i]);
            }
        }

        return gageData;
    }


    cleanData = (readings) => {
        let updatedData = readings.map(data => {
            const dateTime = data.dateReading;
            const dataValue = data.dataValue;
            const newObj = { value: dataValue, dateTime: dateTime }
            return newObj;
        })
        return updatedData;
    }

    cleanBuildingData = (buildings) => {
        let updateBuildingData = buildings.map(data => {
            const bldgID = data.bldgId;
            const bldgType = data.bldgType;
            const surface = data.surface;
            const address = data.address;
            const stage = data.stage;
            const depth = data.depth;
            const hag = data.hag;
            const lag = data.lag;
            const ffe = data.ffe;
            const newObj = { bldgID: bldgID, bldgType: bldgType, surface: surface, address: address, stage: stage, depth: depth, hag: hag, lag: lag, ffe: ffe }
            return newObj;
        })
        return updateBuildingData;
    }

    // get gage Forecast data  from API response
    // clean stageData
    cleanStageForecast = (stage) => {
        let stageDatas = stage.map(data => {
            const timeData = data.children[0].value
            const stageData = data.children[1].value
            const newObj = { value: stageData, dateTime: timeData }
            return newObj
        })
        return stageDatas;
    }

    getBuildingData = (elevation, buildingsState) => {
        API.getImpactedBuildings(elevation).then(response => response.json())
            .then(data => {
                // Need to set the buildings to be displayed in the widget and table as the other values are done...
                if (data.length > 0) {
                    this.setState({ [buildingsState]: data }); // cleanBuildingData(data)
                    let criticalFacilities = data.filter(building => building.occTypGen === "Critical Facility");
                    this.setState({ [`${buildingsState}Critical`]: criticalFacilities });
                } else {
                    this.setState({ [buildingsState]: null }); // cleanBuildingData(data)
                    this.setState({ [`${buildingsState}Critical`]: null });

                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ [buildingsState]: "No Building Impact Data Available" });
            });
    }

    getReturnPeriod = (elevation, periodState) => {
        API.getReturnPeriod(elevation).then(response => response.json())
            .then(data => {
                // Capture the Return Period, display within the Scenario Status section for Scenario...
                this.setState({ [periodState]: data[0].returnPer });
            })
            .catch(err => {
                console.log(err);
                // Display error message on the Return Period...
                this.setState({ [periodState]: "No Return Period Available" });

            });
    }


    setPeakData = (data) => {

        let peakObj = {
            dataValue: null,
        }

        for (let i = 0; i < data.length; i++) {
            if (data[i].dataValue > peakObj.dataValue) {
                peakObj = data[i];
            }
        }

        let peakStage = peakObj.dataValue;
        let peakElevation = peakStage + this.props.gageDatum;
        let peakDateTime = peakObj.dateReading;
        

        this.setState({ peakElevation, peakStage, peakDateTime });

    }

    setFirstForecastRecord = (lastObservedRecord, dataType) => {
        if (dataType === "flow") {
            let newFlowForecast = [...this.state.forecastFlowData]
            newFlowForecast.unshift(lastObservedRecord);
            this.setState({ forecastFlowData: newFlowForecast });
        } else if (dataType === "stage") {
            let newStageForecast = [...this.state.forecastStageData]
            newStageForecast.unshift(lastObservedRecord);
            this.setState({ forecastStageData: newStageForecast });

        }
    }

    // hit api to query database for stage, flow, and stage levels data.  Clean data and set
    // data as state
    setGageData = () => {
        if (this.props.usgsGageID !== null) {
            API.getGage(this.props.usgsGageID).then(response => response.json())
                .then(data => {
                    if (data) {

                        // Need to get and set other gage values and readings that can be used...
                        // Static values related to current and forecast values such as peaks...

                        // setting the default Scenario Slider Value

                        var currentElevation = Math.round(data[0].observedElevation);

                        if (currentElevation > data[0].inundationScenarioMinElv) {
                            this.props.setScenarioSliderValue(currentElevation);
                        } else {
                            this.props.setScenarioSliderValue(data[0].inundationScenarioMinElv);
                        }

                        // Set these value to better set the flooding levels for the charts...
                        var stageAdjustment = data[0].gageDatum;
                        var siteElevation = data[0].gageDatum;

                        var ht_bankfull = data[0].bankFull;
                        var ht_minor = data[0].minor;
                        var ht_moderate = data[0].moderate;
                        var ht_major = data[0].major;

                        var normalValue = Math.round((siteElevation - stageAdjustment) * 10) / 10;

                        var monitorValue = Math.round((ht_bankfull - stageAdjustment) * 10) / 10;
                        var minorValue = Math.round((ht_minor - stageAdjustment) * 10) / 10;
                        var moderateValue = Math.round((ht_moderate - stageAdjustment) * 10) / 10;
                        var majorValue = Math.round((ht_major - stageAdjustment) * 10) / 10;

                        var levels = {
                            normal: normalValue, monitor: monitorValue, minor: minorValue, moderate: moderateValue, major: majorValue
                        };

                        //const allLevels = Data.stageLevelData()
                        //setStageLevels(allLevels[currentGageID]);
                        this.setState({ stageLevels: levels });

                        //setFlowData(cleanNewGageData(data));

                        // Check if forecast is available from the ID and get the data...
                        // May need to be redone...
                        if (this.props.noaaGageID != null /*&& hasForecast*/) {
                            // get all values associated with the NOAA Gage ID

                            // NOAA Forecast Flow
                            API.getNOAAForecast(this.props.noaaGageID, '00060').then(response => response.json())
                                .then(data => {
                                    if (data && data.length > 1) {
                                        this.setState({ forecastFlowData: this.cleanData(data) });
                                    } else {
                                        this.setState({ forecastFlowData: [] });
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    this.setState({ forecastFlowData: [] });
                                });
                            // NOAA Forecast Stage
                            API.getNOAAForecast(this.props.noaaGageID, '00065').then(response => response.json())
                                .then(data => {
                                    if (data && data.length > 1) {
                                        this.setPeakData(data);
                                        //var startingForecast = Math.round(data[0].dataValue + siteElevation);
                                        this.props.setForecastSliderValue(currentElevation);
                                        this.setState({ forecastStageData: this.cleanData(data) });
                                    } else {
                                        this.setState({ forecastStageData: []});
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    this.setState({ forecastStageData: [] });
                                });
                        }

                        // USGS Observed Flow - clean observed flow and set state, then take last observed record
                        // and set as first forecast record
                        API.getUSGSObserved(this.props.usgsGageID, '00060').then(response => response.json())
                            .then(data => {
                                if (data && data.length > 1) {
                                    data = this.cleanNewGageData(data)
                                    let cleanedData = this.cleanData(data);
                                    this.setState({ observedFlowData: cleanedData });
                                    this.setFirstForecastRecord(cleanedData[cleanedData.length - 1], "flow");
                                } else {
                                    this.setState({ observedFlowData: []});
                                }
                            })
                            .catch(err => {
                                console.log(err);
                                this.setState({ observedFlowData: [] });
                            });

                        // USGS Observed Stage - clean observed stage and set state, then take last observed record
                        // and set as first forecast record
                        API.getUSGSObserved(this.props.usgsGageID, '00065').then(response => response.json())
                            .then(data => {
                                if (data && data.length > 1) {
                                    data = this.cleanNewGageData(data);
                                    let cleanedData = this.cleanData(data);
                                    this.props.setCurrentStage(data[data.length - 1].dataValue);
                                    this.props.setCurrentElevation(currentElevation);
                                    this.setState({ observedStageData: cleanedData });
                                    this.setFirstForecastRecord(cleanedData[cleanedData.length - 1], "stage");
                                } else {
                                    this.setState({ observedStageData:[] });
                                }
                            })
                            .catch(err => {
                                console.log(err);
                                this.setState({ observedStageData: [] });
                            });

                        // Get the Building Impact Data
                        // Need to capture the current gage elevation and pass that into the parameter...
                        API.getImpactedBuildings(this.props.currentElevation).then(response => response.json())
                            .then(data => {
                                // Need to check if returns an empty array which it may due to the procedure return, not just the error check is good enough...
                                //if (data.length > 0) {
                                // Need to set the buildings to be displayed in the widget and table as the other values are done...
                                this.setState({ buildingsCurrent: data }); // cleanBuildingData(data)
                                //} else {
                                //    this.setState({ buildingsCurrent: "No Building Impact Data Available" });
                                //}                            
                            })
                            .catch(err => {
                                console.log(err);
                                this.setState({ buildingsCurrent: [] });
                            });

                    } else {
                        //setFlowData("no gage Data Available");
                    }
                })
                .catch(err => {
                    console.log(err);
                    //setFlowData("no gage Data Available");
                });
        }
    }

    componentDidMount() {
        if (this.props.usgsGageID != null) {
            // get all values associated with the USGS Gage ID
            this.setGageData();            
        }
    }

    // if gage selection changes, grab updated data
    componentDidUpdate(prevProps) {

        if (prevProps.usgsGageID !== this.props.usgsGageID) {
            this.setGageData();
        }

        if (prevProps.refreshData !== this.props.refreshData) {
            this.setGageData();
        }

        if (prevProps.currentElevation !== this.props.currentElevation) {
            this.setState({ currentElevation: this.props.currentElevation });
            this.getBuildingData(this.props.currentElevation, "buildingsCurrent");
        }

        if (prevProps.scenarioSliderValue !== this.props.scenarioSliderValue) {
            this.setState({ scenarioSliderValue: this.props.scenarioSliderValue });
            this.getBuildingData(this.props.scenarioSliderValue, "buildingsScenario");
            this.getReturnPeriod(this.props.scenarioSliderValue, "returnPeriod");
        }

        if ((prevProps.forecastStageValue !== this.props.forecastStageValue) || (prevProps.forecastDateReading !== this.props.forecastDateReading)) {
            this.setState({ forecastSliderValue: this.props.forecastSliderValue });
            this.setState({ forecastStageValue: this.props.forecastStageValue });
            this.setState({ forecastDateReading: this.props.forecastDateReading });
            this.getBuildingData(this.props.forecastSliderValue, "buildingsForecast");

        }
    }


    renderDashboard = (state) => {
        switch (state) {
            case 'current':
                return <Current2
                    usgsGageID={this.props.usgsGageID}
                    noaaGageID={this.props.noaaGageID}
                    gageDatum={this.props.gageDatum}
                    gageName={this.props.gageName}
                    observedStageData={this.state.observedStageData}
                    forecastStageData={this.state.forecastStageData}
                    stageLevels={this.state.stageLevels}
                    observedFlowData={this.state.observedFlowData}
                    forecastFlowData={this.state.forecastFlowData}
                    totalData={this.state.totalData}
                    currentElevation={this.state.currentElevation}
                    buildingsCurrent={this.state.buildingsCurrent}
                    buildingsCurrentCritical={this.state.buildingsCurrentCritical}
                    setBuildingMarker={this.props.setBuildingMarker}
                    setCenterAndZoom={this.props.setCenterAndZoom}
                    setRefreshData={this.props.setRefreshData}
                />;
            case 'scenario':
                return <Scenario2
                    usgsGageID={this.props.usgsGageID}
                    noaaGageID={this.props.noaaGageID}
                    gageDatum={this.props.gageDatum}
                    gageName={this.props.gageName}
                    observedStageData={this.state.observedStageData}
                    forecastStageData={this.state.forecastStageData}
                    stageLevels={this.state.stageLevels}
                    observedFlowData={this.state.observedFlowData}
                    forecastFlowData={this.state.forecastFlowData}
                    totalData={this.state.totalData}
                    buildingsScenario={this.state.buildingsScenario}
                    buildingsScenarioCritical={this.state.buildingsScenarioCritical}
                    setCenterAndZoom={this.props.setCenterAndZoom}
                    setBuildingMarker={this.props.setBuildingMarker}
                    scenarioSliderValue={this.state.scenarioSliderValue}
                    returnPeriod={this.state.returnPeriod}
                />;
            case 'forecast':
                return <Forecast
                    usgsGageID={this.props.usgsGageID}
                    noaaGageID={this.props.noaaGageID}
                    gageDatum={this.props.gageDatum}
                    gageName={this.props.gageName}
                    observedStageData={this.state.observedStageData}
                    forecastStageData={this.state.forecastStageData}
                    forecastDateReading={this.state.forecastDateReading}
                    stageLevels={this.state.stageLevels}
                    observedFlowData={this.state.observedFlowData}
                    forecastFlowData={this.state.forecastFlowData}
                    totalData={this.state.totalData}
                    buildingsForecast={this.state.buildingsForecast}
                    buildingsForecastCritical={this.state.buildingsForecastCritical}
                    setCenterAndZoom={this.props.setCenterAndZoom}
                    setBuildingMarker={this.props.setBuildingMarker}
                    forecastSliderValue={this.state.forecastSliderValue}
                    forecastStageValue={this.state.forecastStageValue}
                    peakElevation={this.state.peakElevation}
                    peakStage={this.state.peakStage}
                    peakDateTime={this.state.peakDateTime}
                />;
            default:
                return null;
        }
    }



    render() {
        return (
            <div>

                {/* if a gage is selected (props passed w/ current gage name), return dashboard container.  Else return empty fragment. */}
                {this.props.dashboardView ?
                    <Container className="dashboardWrapper">
                        {/*renders the correct dashboard components depending on user click actions*/}
                        {this.renderDashboard(this.props.dashboardView)}
                    </Container>
                    :
                    <div></div>
                }
            </div>
        );

    }
};

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/Dashboard2/index.js